
import { defineComponent } from 'vue'

// paper information
interface PaperInfo {
  type: string,
  title: string,
  url?: string,
  text: string,
  note?: string
}

export default defineComponent({
  data () {
    return {
      theses: [
        {
          type: '博士論文',
          title: 'Modern classification theory of superconducting gap nodes',
          url: 'theses/phd_thesis.pdf',
          text: '2020年3月23日 博士(理学) 取得',
          note: '(<a href="https://doi.org/10.14989/doctor.k22236" target="_blank">京都大学学術情報リポジトリ 紅</a>)'
        },
        {
          type: '修士論文',
          title: '磁気多極子秩序と共存する超伝導の研究',
          url: 'theses/ms_thesis.pdf',
          text: '2017年3月23日 修士(理学) 取得'
        }
      ] as PaperInfo[]
    }
  }
})
